export const authRoles = {
  sa: ["SA"], // Super Admin
  admin: ["SA", "ADMIN", "administrator"], // Admin, Super Admin, and Administrator
  teacher: ["teacher"], // Teacher role
  librarian: ["librarian"], // Librarian role
  adminTeacher: ["SA", "ADMIN", "teacher", "administrator"], // Combined roles
  adminTeacherStudent: ["SA", "ADMIN", "teacher", "administrator", "student"],
  student: ["student"]
};
